import { I18n } from 'common/i18n';

export enum Tense {
  Present,
  Past,
}
export const pastOrPresentChangeLabel = (scope: string) => (k: string, t: Tense) => {
  return I18n.t(k, { scope: `${scope}.${t === Tense.Past ? 'past' : 'present'}` });
};
